import { WandSparklesIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toCodeIdentifier } from "@/lib/utils";

interface CodeGenerateButtonProps {
  sourceName: string;
  onGenerate: (code: string) => void;
  disabled?: boolean;
}

export function CodeGenerateButton({
  sourceName,
  onGenerate,
  disabled,
}: CodeGenerateButtonProps) {
  const generated = toCodeIdentifier(sourceName);
  const isDisabled = disabled || generated.length === 0;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="size-7 shrink-0"
      disabled={isDisabled}
      title={
        isDisabled
          ? "Enter a name first"
          : `Generate code from name: ${generated}`
      }
      onClick={() => {
        if (!isDisabled) onGenerate(generated);
      }}
    >
      <WandSparklesIcon className="size-3" />
    </Button>
  );
}

export default CodeGenerateButton;
